import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { APP_TITLE } from '@core/constants';

import { HomeMapComponent as HomeComponent } from './pages/home-map/home-map.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'page/:page',
        component: HomeComponent,
      },
      {
        path: 'page/:page/states',
        component: HomeComponent,
      },
      {
        path: 'page/:page/states/:states',
        component: HomeComponent,
      },
      {
        path: 'auth/password-reset',
        component: HomeComponent,
        title: APP_TITLE('Password reset'),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
